module.exports = __webpack_public_path__ + "img/icraproweblogo.a778e798.svg";